/* eslint-disable @typescript-eslint/prefer-nullish-coalescing */
/* eslint-disable quote-props */
import { AlertDialog, AlertDialogBody, AlertDialogContent, AlertDialogFooter, AlertDialogHeader, AlertDialogOverlay, Box, Button, Flex, FormControl, Text, useOutsideClick, useToast } from '@chakra-ui/react'
import { List } from 'immutable'

import { useEffect, useMemo, useRef, useState } from 'react'
import { FaPencilAlt, FaPlus, FaTrash } from 'react-icons/fa'
import { MdClose } from 'react-icons/md'
import Modal from 'react-modal'
import { iCargosPendentes } from '../..'
import { ButtonCmp } from '../../../../../components/ButtonCmp'
import { ElementoTooltipCmp } from '../../../../../components/ElementoTooltipCmp'
import { InputCmp } from '../../../../../components/InputCmp'
import LoadingContainer from '../../../../../components/LoadingContainer'
import { ModalDelete } from '../../../../../components/ModalDelete'
import { SelectCmp } from '../../../../../components/SelectCmp'
import { DescricaoCargo, iCargosSuperiores, iNomeId, iTrilhaDeCarreira } from '../../../../../interfaces'
import { appApi } from '../../../../../services/appApi'
import { ModalNivel } from '../ModalNivel'
import { WhiteModal } from './styles'

export interface iDescritivoInput {
  id?: string
  nomeCargo: string
  trilhas: iTrilhaDeCarreira[]
  cargosSuperiores?: iCargosSuperiores[]
  tipoNivel: string
  atuacao: string
  hierarquia: string
  areaId: string
  cbo: string
  funcaoId?: string
}

export interface iNivelCargo {
  id: string
  nome: string
  niveis: string[]
}

interface iModalProps {
  isOpen: boolean
  onCreate: (item: iDescritivoInput, isEdit: boolean) => void
  onClose: () => void
  modelEdit?: DescricaoCargo
  cargos?: DescricaoCargo[]
  departamentos: iNomeId[]
  onReloadDeps: () => void
  CargosPendentes?: List<iCargosPendentes>
  getFuncoesEmPendencia?: () => void
  prefillFuncao?: iCargosPendentes | null
}

type InvalidFlags = {
  TipoNivelTrue: boolean
  NomeCargoTrue: boolean
  AtuacaoTrue: boolean
  HierarquiaTrue: boolean
  AreaTrue: boolean
  TrilhasTrue: boolean
  CboTrue: boolean
}

type CriarFuncaoResponse = {
  id: string
  nome: string
}

export const ModalCreate: React.FC<iModalProps> = ({ isOpen, onClose, onCreate, modelEdit, cargos, departamentos, onReloadDeps, CargosPendentes, getFuncoesEmPendencia, prefillFuncao }) => {
  const toast = useToast()

  const [invalidFlags, setInvalidFlags] = useState<InvalidFlags>({
    TipoNivelTrue: false,
    NomeCargoTrue: false,
    AtuacaoTrue: false,
    HierarquiaTrue: false,
    AreaTrue: false,
    TrilhasTrue: false,
    CboTrue: false
  })
  const [IsCreating, setIsCreating] = useState(false)
  const [ModalNivelIsOpen, setModalNivelIsOpen] = useState(false)
  const [ModalDeleteIsOpen, setModalDeleteIsOpen] = useState(false)
  const [TextoDelete, setTextoDelete] = useState<string>('')
  const [NiveisExtra, setNiveisExtra] = useState<iNivelCargo[]>([])
  const [model, setModel] = useState<iDescritivoInput>({
    nomeCargo: '',
    tipoNivel: '',
    trilhas: [],
    atuacao: '',
    hierarquia: '',
    areaId: '',
    cbo: '',
    funcaoId: undefined,
    cargosSuperiores: []
  })
  const [NivelId, setNivelId] = useState<string>('')
  const [CargoDropDownOpen, setCargoDropdownOpen] = useState<boolean>(false)
  const cargoDropDownRef = useRef<HTMLDivElement | null>(null)
  const [cargoSelecionado, setCargoSelecionado] = useState<iCargosPendentes | null>(null)
  const [confirmCreateOpen, setConfirmCreateOpen] = useState<boolean>(false)
  const cancelRef = useRef<HTMLButtonElement | null>(null)
  const nomeNovoCargo: string = (model.nomeCargo ?? '').trim()
  const isEdit: boolean = !!modelEdit
  const [qtdColaboradores, setQtdColaboradores] = useState<number>(0)
  const [ModalEditarNomeOpen, setModalEditarNomeOpen] = useState(false)
  const [liberarEdicaoNome, setLiberarEdicaoNome] = useState<boolean>(false)

  function buscarNomeCargoPorID(id: string): string {
    const nomeCargo = Cargos?.find((c) => c.id === id)?.nomeCargo ?? ''
    return nomeCargo
  }

  async function onConfirmCriarCargo(): Promise<void> {
    const criado = await criarCargo()
    if (!criado) return
    handleChange('funcaoId', criado.id)
    handleChange('nomeCargo', criado.nome)

    setCargoSelecionado({
      id: criado.id,
      nome: criado.nome,
      temCargo: false
    })

    setConfirmCreateOpen(false)
    setCargoDropdownOpen(false)
  }

  async function criarCargo(): Promise<CriarFuncaoResponse | null> {
    const form = {
      nome: nomeNovoCargo
    }
    try {
      const res = await appApi.post<CriarFuncaoResponse>('Cargo', form)
      toast({
        title: 'Nome do cargo criada',
        status: 'success',
        duration: 3000,
        position: 'top'
      })
      if (getFuncoesEmPendencia) getFuncoesEmPendencia()
      return res.data
    } catch (err) {
      console.log(err)
      toast({
        title: 'Não foi possível criar o nome do cargo',
        status: 'error',
        duration: 3000,
        position: 'top'
      })
      return null
    }
  }

  function onCancelCriarCargo(): void {
    setConfirmCreateOpen(false)
  }

  useOutsideClick({
    ref: cargoDropDownRef,
    handler: () => setCargoDropdownOpen(false)
  })

  const CargosPendentesSafe: List<iCargosPendentes> = CargosPendentes ?? List<iCargosPendentes>()

  const cargosPendentesFiltrados = useMemo<List<iCargosPendentes>>(
    (): List<iCargosPendentes> => {
      const q: string = (model.nomeCargo ?? '').trim().toLowerCase()
      if (!q) return CargosPendentesSafe

      return CargosPendentesSafe.filter(
        (c?: iCargosPendentes): boolean =>
          !!c && c.nome.toLowerCase().includes(q)
      ) as List<iCargosPendentes>
    },
    [model.nomeCargo, CargosPendentesSafe]
  )

  function onSelectCargoPendente(cargo: iCargosPendentes): void {
    setCargoSelecionado(cargo)
    handleChange('nomeCargo', cargo.nome)
    handleChange('funcaoId', cargo.id)
    setCargoDropdownOpen(false)
  }

  function clearCargoSelecionado(): void {
    setCargoSelecionado(null)
    handleChange('funcaoId', '')
    handleChange('nomeCargo', '')
    setCargoDropdownOpen(false)
  }

  const tipoNivelOptions = [
    'Único',
    'Júnior/Pleno/Sênior',
    'I, II e III',
    'I, II, III, IV e V'
  ]

  function handleChange<K extends keyof iDescritivoInput>(field: K, value: string): void {
    setModel(prev => ({
      ...prev,
      [field]: value
    }))
  }

  // A area da trilha nao e mais escolhida a parte: vem do cargo selecionado como proximo passo
  function handleTrilhaChange(index: number, cargoSuperiorId: string): void {
    const cargoEscolhido = (Cargos ?? []).find(c => c.id === cargoSuperiorId)
    const updated = [...model.trilhas]

    updated[index] = {
      ...updated[index],
      cargoSuperiorId,
      cargoSuperiorNome: cargoEscolhido?.nomeCargo,
      areaId: cargoEscolhido?.areaId ?? '',
      areaNome: cargoEscolhido?.areaNome
    }

    setModel(prev => ({ ...prev, trilhas: updated }))
  }

  function handleCargosSuperioresChange(index: number, field: 'cargoSuperiorId', value: string, nome: string): void {
    if (!model.cargosSuperiores) return
    const updated = [...model.cargosSuperiores]
    updated[index][field] = value
    updated[index].nome = nome
    setModel(prev => ({ ...prev, cargosSuperiores: updated }))
  }

  function addTrilha(): void {
    setModel(prev => ({ ...prev, trilhas: [...prev.trilhas, { areaId: '', cargoSuperiorId: '' }] }))
  }

  function addCargoSuperior(): void {
    setModel(prev => ({ ...prev, cargosSuperiores: [...prev.cargosSuperiores ?? [], { nome: '', cargoSuperiorId: '' }] }))
  }

  function removeTrilha(index: number): void {
    setModel(prev => ({
      ...prev,
      trilhas: prev.trilhas.filter((_, i) => i !== index)
    }))
  }

  function removeCargoSuperior(index: number): void {
    setModel(prev => ({
      ...prev,
      cargosSuperiores: prev.cargosSuperiores?.filter((_, i) => i !== index)
    }))
  }

  const [Cargos, setCargos] = useState<DescricaoCargo[] | undefined>()
  const [IsLoading, setIsLoading] = useState(false)
  const descendentes = (modelEdit && (cargos || Cargos)) ? getDescendentes(modelEdit.id, cargos ?? Cargos) : new Set()

  function handleCreate(): void {
    // O backend espera Guid em areaId: string vazia derruba o POST com 400
    const guidVazio = '00000000-0000-0000-0000-000000000000'
    onCreate({ ...model, trilhas: model.trilhas.map(e => { return { ...e, areaId: e.areaId !== '' ? e.areaId : guidVazio, cargoSuperiorId: e.cargoSuperiorId !== '' ? e.cargoSuperiorId : undefined } }) }, !!modelEdit)
  }

  function checkCreate(): void {
    const next = { ...invalidFlags }
    let firstMessage: string | null = null
    let anyInvalid = false

    const mark = (failed: boolean, key: keyof typeof next, msg: string): void => {
      if (failed) {
        next[key] = true
        anyInvalid = true
        if (!firstMessage) firstMessage = msg
      } else {
        next[key] = false
      }
    }

    mark(!model.tipoNivel?.trim(), 'TipoNivelTrue', 'Tipo de nível é obrigatório')
    mark(!model.nomeCargo?.trim(), 'NomeCargoTrue', 'Selecione o nome do cargo')
    mark(!model.atuacao?.trim(), 'AtuacaoTrue', 'Atuação é obrigatória')
    mark(!model.hierarquia?.trim(), 'HierarquiaTrue', 'Hierarquia é obrigatória')
    mark(!model.areaId?.trim(), 'AreaTrue', 'Área é obrigatória')
    mark(!model.cbo?.trim(), 'CboTrue', 'CBO é obrigatória')
    mark(!isEdit && (!model.funcaoId || model.funcaoId.trim() === ''), 'NomeCargoTrue', 'Selecione o nome do cargo')

    mark(!Array.isArray(model.trilhas), 'TrilhasTrue', 'Trilhas é obrigatório')

    if (model.tipoNivel.includes('Nível excluído do sistema, atualize por um novo')) {
      mark(!model.tipoNivel?.trim(), 'TipoNivelTrue', 'O nível selecionado foi excluído do sistema em um momento passado, por favor substitua ele por um novo para conseguir atualizar esse cargo')
      toast({
        title: 'O nível selecionado foi excluído do sistema em um momento passado, por favor substitua ele por um novo para conseguir atualizar esse cargo',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    setInvalidFlags(next)

    if (anyInvalid) {
      toast({
        title: firstMessage ?? 'Há campos inválidos',
        status: 'error',
        duration: 4000,
        position: 'top'
      })
      return
    }

    let textoDelete = ''

    if (modelEdit && model.tipoNivel !== modelEdit.tipoNivel) {
      const tipoNivelOptionsMap: Record<string, number> = {
        'Único': 1,
        'Júnior/Pleno/Sênior': 3,
        'I, II e III': 3,
        'I, II, III, IV e V': 5
      }

      const anteriorExtra = NiveisExtra.find(n => n.nome === modelEdit.tipoNivel)
      const atualExtra = NiveisExtra.find(n => n.nome === model.tipoNivel)

      const anteriorPadrao = tipoNivelOptionsMap[modelEdit.tipoNivel]
      const atualPadrao = tipoNivelOptionsMap[model.tipoNivel]

      const qtdAnterior = anteriorExtra?.niveis.length ?? anteriorPadrao
      const qtdAtual = atualExtra?.niveis.length ?? atualPadrao

      if (qtdAnterior !== undefined && qtdAtual !== undefined) {
        if (qtdAnterior === qtdAtual) {
          textoDelete = 'Os níveis terão os nomes substituídos e vão se manter com os mesmos itens e atributos.'
        } else if (qtdAtual > qtdAnterior) {
          textoDelete = 'Serão criados os níveis extras com valores vazios e os primeiros níveis serão mantidos.'
        } else {
          textoDelete = 'Os níveis finais serão excluídos e será mantido apenas os primeiros itens.'
        }
      } else {
        textoDelete = 'A estrutura dos níveis será atualizada para o novo tipo selecionado.'
      }
    }

    if (textoDelete === '') {
      setTextoDelete('')
      handleCreate()
    } else {
      setTextoDelete(textoDelete)
    }
  }

  function getDescendentes(cargoId: string, cargos?: DescricaoCargo[]): Set<string> {
    const descendentes = new Set<string>()

    function buscarFilhos(id: string): void {
      cargos?.forEach(c => {
        // Sem essa checagem, um ciclo nos dados (trilha A -> B -> ... -> A) recursa pra sempre
        if (descendentes.has(c.id)) return

        const possuiLigacao = c.trilhasDeCarreira?.some(trilha => trilha.cargoSuperiorId === id)
        if (possuiLigacao) {
          descendentes.add(c.id)
          buscarFilhos(c.id)
        }
      })
    }

    buscarFilhos(cargoId)
    return descendentes
  }

  useEffect(() => {
    if (!isOpen) return

    if (modelEdit) {
      setModel({
        id: modelEdit.id,
        nomeCargo: modelEdit.nomeCargo,
        atuacao: modelEdit.atuacao,
        cbo: modelEdit.cbo,
        hierarquia: modelEdit.nivelHierarquico,
        areaId: modelEdit.areaId ?? '',
        trilhas: modelEdit.trilhasDeCarreira.length === 0 ? [{ areaId: '', cargoSuperiorId: '' }] : modelEdit.trilhasDeCarreira,
        tipoNivel: (!tipoNivelOptions.some(e => e === modelEdit.tipoNivel) && !NiveisExtra.some(e => e.nome === modelEdit.tipoNivel) && NiveisExtra.length > 0)
          ? `${modelEdit.tipoNivel} (Nível excluído do sistema, atualize por um novo)`
          : modelEdit.tipoNivel,
        funcaoId: modelEdit.funcaoId ?? '',
        cargosSuperiores: modelEdit.cargosSuperiores && modelEdit.cargosSuperiores.length === 0 ? [{ nome: '', cargoSuperiorId: '' }] : modelEdit.cargosSuperiores
      })

      setCargoSelecionado(null)
      return
    }
    setModel({
      nomeCargo: prefillFuncao?.nome ?? '',
      tipoNivel: '',
      atuacao: '',
      hierarquia: '',
      areaId: '',
      trilhas: [{ areaId: '', cargoSuperiorId: '' }],
      cbo: '',
      funcaoId: prefillFuncao?.id ?? '',
      cargosSuperiores: [{ nome: '', cargoSuperiorId: '' }]
    })

    setCargoSelecionado(prefillFuncao ?? null)

    setCargoDropdownOpen(false)
  }, [isOpen, modelEdit, prefillFuncao, NiveisExtra])

  function GetDescritivos(): void {
    setIsLoading(true)

    appApi.get('api/CargosESalarios')
      .then((res) => {
        setCargos(res.data)
        if (modelEdit) getDescendentes(modelEdit.id, res.data)
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function GetNiveisExtra(novoId?: string): void {
    setIsLoading(true)

    appApi.get('api/NivelCargo')
      .then((res) => {
        setNiveisExtra(res.data)
        if (novoId) {
          setNivelId(novoId)
          const nivel = res.data.find((e: iNivelCargo) => e.id === novoId)
          setModel({ ...model, tipoNivel: nivel?.nome ?? '' })
          setModalNivelIsOpen(false)
        }
        if (modelEdit && !novoId) {
          const nivelExtra = res.data.find((e: iNivelCargo) => e.nome === modelEdit.tipoNivel)
          if (nivelExtra) {
            setNivelId(nivelExtra.id)
          }
        }
      })
      .catch(err => console.log(err))
      .finally(() => setIsLoading(false))
  }

  function DeleteNivel(): void {
    appApi.delete(`api/NivelCargo/${NivelId}`)
      .then(res => {
        GetNiveisExtra()
        setModel({ ...model, tipoNivel: '' })
        toast({
          title: 'Nível excluído com sucesso',
          status: 'success',
          duration: 4000,
          position: 'top'
        })
      })
      .catch(err => console.log(err))
      .finally(() => setNivelId(''))
  }

  function onSaveNivel(e: string): void {
    GetNiveisExtra(e)
  }

  function GetQuantidadeColaboradores(id: string): void {
    appApi.get<number>(`cargo/quantidadeColaboradores/${id}`)
      .then((res) => {
        setQtdColaboradores(res.data)
      })
      .catch(err => console.log(err))
  }

  function acaoEditarNome(funcaoId?: string): void {
    if (!funcaoId) return

    GetQuantidadeColaboradores(funcaoId)
    setModalEditarNomeOpen(true)
  }

  function onConfirmEditarNome(): void {
    setLiberarEdicaoNome(true)
    setModalEditarNomeOpen(false)
  }

  useEffect(() => {
    setIsCreating(false)
  }, [NivelId])

  useEffect(() => {
    if (IsCreating) {
      setModalNivelIsOpen(true)
    }
  }, [IsCreating])

  useEffect(() => {
    if (!cargos && isOpen) {
      GetDescritivos()
    } else {
      setCargos(cargos)
    }

    if (isOpen) {
      GetNiveisExtra()
    } else {
      setNivelId('')
      setInvalidFlags({
        TipoNivelTrue: false,
        NomeCargoTrue: false,
        AtuacaoTrue: false,
        HierarquiaTrue: false,
        AreaTrue: false,
        TrilhasTrue: false,
        CboTrue: false
      })
    }
  }, [cargos, isOpen])

  useEffect(() => {
    if (!isOpen) {
      setLiberarEdicaoNome(false)
    }
  }, [isOpen])

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      overlayClassName="react-modal-overlay"
      className="react-modal-content-default"
    >
      {TextoDelete !== '' && <ModalDelete
        isOpen
        message={TextoDelete}
        onConfirm={handleCreate}
        onRequestClose={() => setTextoDelete('')}
        center
      />}
      <ModalNivel
        isOpen={ModalNivelIsOpen}
        onClose={() => { setModalNivelIsOpen(false); setIsCreating(false) }}
        onSave={(e) => { onSaveNivel(e) }}
        nivel={IsCreating ? undefined : NiveisExtra.find(e => e.id === NivelId)}
      />
      <ModalDelete
        isOpen={ModalDeleteIsOpen}
        onConfirm={DeleteNivel}
        onRequestClose={() => { setModalDeleteIsOpen(false) }}
        message='Tem certeza que deseja excluir essa nível?'
        center
      />
      <AlertDialog
      isOpen={ModalEditarNomeOpen}
      leastDestructiveRef={cancelRef}
      onClose={() => setModalEditarNomeOpen(false)}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
        <AlertDialogHeader fontSize="lg" fontWeight="bold">
          Editar nome do cargo
        </AlertDialogHeader>

        <AlertDialogBody>
          <Text mb="10px">
            Este cargo possui <b>{qtdColaboradores}</b> colaborador(es). Deseja alterar o nome?
          </Text>
        </AlertDialogBody>

        <AlertDialogFooter>
          <Button
            ref={cancelRef as any}
            onClick={() => setModalEditarNomeOpen(false)}
            color="black"
          >
            Cancelar
          </Button>

          <ButtonCmp
            VarColor="Green2"
            onClick={async () => {
              onConfirmEditarNome()
            }}
            style={{ marginLeft: 8 }}
          >
            Confirmar
          </ButtonCmp>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>

      <AlertDialog
      isOpen={confirmCreateOpen}
      leastDestructiveRef={cancelRef}
      onClose={onCancelCriarCargo}
      isCentered
    >
      <AlertDialogOverlay />
      <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Criar nome do cargo
          </AlertDialogHeader>

          <AlertDialogBody>
            Você deseja criar um nome de cargo <b>{nomeNovoCargo || '(sem nome)'}</b>? <br /> (A visualização do cargo ficará disponível no Organograma)
          </AlertDialogBody>

          <AlertDialogFooter>
            <Button
              ref={cancelRef as any}
              onClick={onCancelCriarCargo}
              color="black"
            >
              Não, voltar
            </Button>

            <ButtonCmp
              VarColor="Green2"
              onClick={onConfirmCriarCargo}
              style={{ marginLeft: 8 }}
            >
              Sim, criar
            </ButtonCmp>
          </AlertDialogFooter>
      </AlertDialogContent>
      </AlertDialog>

      <LoadingContainer loading={IsLoading} linhas={12}>
        <WhiteModal>
          <FormControl as={Flex} flexDir="column" gap="1rem">
            <Flex justifyContent={'space-between'}>
              <h3 style={{ fontSize: '20px', fontWeight: 'bold', color: 'var(--Azul)' }}>
                {modelEdit ? 'Editar cargo' : 'Novo cargo'}
              </h3>
              <Flex color='var(--Red)' _hover={{ color: 'var(--Red-hover)' }}>
                <MdClose cursor={'pointer'} size={18} onClick={onClose}/>
              </Flex>
            </Flex>
            <Flex flexDir={'column'} gap="1rem">
              <Flex gap={'1rem'}>
                <Box ref={cargoDropDownRef as any} position="relative" width="100%">
                  <InputCmp
                  label="Nome do cargo *"
                  value={model.nomeCargo}
                  placeholder="Digite o nome do cargo..."
                  OnChange={(v) => {
                    if (!isEdit && cargoSelecionado) return

                    handleChange('nomeCargo', v)

                    if (!isEdit) {
                      handleChange('funcaoId', '')
                      setCargoSelecionado(null)
                      setCargoDropdownOpen(true)
                    }
                  }}
                  isInvalid={invalidFlags.NomeCargoTrue}
                  isReadOnly={(isEdit || !!cargoSelecionado) && !liberarEdicaoNome}
                  onFocus={(): void => {
                    if (!isEdit && !cargoSelecionado) setCargoDropdownOpen(true)
                  }}
                />

                {(cargoSelecionado || isEdit) && !liberarEdicaoNome && (
                  <Box
                    position="absolute"
                    right="10px"
                    top="60%"
                    transform="translateY(-50%)"
                    cursor="pointer"
                    color="red.500"
                    _hover={{ color: 'gray.500' }}
                    onMouseDown={(e): void => {
                      e.preventDefault()

                      if (isEdit) {
                        acaoEditarNome(model.funcaoId)
                        setConfirmCreateOpen(false)
                        return
                      }

                      clearCargoSelecionado()
                    }}
                  >
                    ✕
                  </Box>
                )}

                  {CargoDropDownOpen && !cargoSelecionado && !isEdit && (
                    <Box
                      position="absolute"
                      top="100%"
                      left={0}
                      right={0}
                      mt="6px"
                      bg="white"
                      border="1px solid"
                      borderColor="gray.200"
                      borderRadius="8px"
                      boxShadow="lg"
                      zIndex={9999}
                      maxH="240px"
                      overflowY="auto"
                    >
                      {cargosPendentesFiltrados.size === 0
                        ? (
                        <Box
                          p="10px"
                          color="blue.400"
                          cursor="pointer"
                          _hover={{ textDecoration: 'underline' }}
                          onMouseDown={(): void => {
                            if (!nomeNovoCargo) {
                              toast({
                                title: 'Digite o nome do cargo',
                                status: 'warning',
                                duration: 3000,
                                position: 'top'
                              })
                              return
                            }
                            setCargoDropdownOpen(false)
                            setConfirmCreateOpen(true)
                          }}
                        >
                          Criar nome do cargo
                      </Box>

                          )
                        : (
                            cargosPendentesFiltrados.map((c?: iCargosPendentes): JSX.Element | null => {
                              if (!c) return null

                              return (
                                <Box
                                  key={c.id}
                                  px="12px"
                                  py="10px"
                                  cursor="pointer"
                                  _hover={{ bg: 'gray.50' }}
                                  onMouseDown={(): void => onSelectCargoPendente(c)}
                                >
                                  <Text fontWeight="600">{c.nome}</Text>
                                  <Text fontSize="12px" color="gray.600">
                                    {c.temCargo ? ' • já tem cargo' : ''}
                                  </Text>
                                </Box>
                              )
                            }) as any

                          )}
                    </Box>
                  )}
                </Box>
                <Flex gap={'.5rem'} alignItems={'end'} mb={'.75rem'} w={'100%'}>
                  <SelectCmp
                    w={'100%'}
                    title="Tipo de nível *" placeholder={'Selecione o tipo de nível...'}
                    value={model.tipoNivel}
                    isInvalid={invalidFlags.TipoNivelTrue}
                    OnChange={(v) => {
                      handleChange('tipoNivel', v)
                      if (NiveisExtra.some(n => n.nome === v)) {
                        setNivelId(NiveisExtra.find(n => n.nome === v)?.id ?? '')
                      } else {
                        setNivelId('')
                      }
                    }}
                  >
                    <option value={''}>Nenhuma</option>
                    {modelEdit && !tipoNivelOptions.some(e => e === modelEdit.tipoNivel) && !NiveisExtra.some(e => e.nome === modelEdit.tipoNivel) && <option value={`${modelEdit.tipoNivel} (Nível excluído do sistema, atualize por um novo)`}>{modelEdit.tipoNivel} (Nível excluído do sistema, atualize por um novo)</option>}
                    {tipoNivelOptions.map(e => (
                      <option key={e} value={e}>{e}</option>
                    ))}
                    {NiveisExtra.map(e => {
                      return (
                        <option value={e.nome}>{e.nome}</option>
                      )
                    })}
                  </SelectCmp>
                  <ElementoTooltipCmp bg={'var(--Azul)'} label={'Criar nível'}>
                      <ButtonCmp VarColor='Green2' onClick={() => { setIsCreating(true) }}><FaPlus /></ButtonCmp>
                    </ElementoTooltipCmp>
                    <ElementoTooltipCmp bg={'var(--Rosa)'} label={NivelId !== '' ? '' : 'Selecione um nível criado para poder editá-lo'}>
                      <ButtonCmp VarColor='Rosa' disabled={NivelId === ''} onClick={() => setModalNivelIsOpen(true)}><FaPencilAlt /></ButtonCmp>
                    </ElementoTooltipCmp>
                    <ElementoTooltipCmp bg={'var(--Red)'} label={NivelId !== '' ? '' : 'Selecione um nível criado para poder excluí-lo'}>
                      <ButtonCmp VarColor='Red' disabled={NivelId === ''} onClick={() => setModalDeleteIsOpen(true)}><FaTrash /></ButtonCmp>
                    </ElementoTooltipCmp>
                </Flex>
              </Flex>

              <Flex gap={'1rem'}>
                <SelectCmp
                  w={'100%'}
                  title="Área *"
                  placeholder={'Selecione a área...'}
                  isInvalid={invalidFlags.AreaTrue}
                  value={model.areaId}
                  OnChange={(v) => handleChange('areaId', v)}
                >
                  <option value="">Selecionar área</option>
                  {departamentos.map(d => (
                    <option key={d.id} value={d.id}>{d.nome}</option>
                  ))}
                </SelectCmp>
              </Flex>

              <Flex flexDir={'column'} gap={'.75rem'} alignItems={'end'} w={'100%'}>
                {model.trilhas.map((trilha, index) => {
                  return (
                    <Flex key={index} gap="1rem" align="flex-end" w={'100%'}>
                      <SelectCmp
                        w="100%"
                        title={`Próximo cargo da trilha (${index + 1})`}
                        placeholder="Selecione o cargo superior..."
                        value={trilha.cargoSuperiorId}
                        OnChange={(v) => handleTrilhaChange(index, v)}
                      >
                        <option value="">Ninguém (Topo da hierarquia)</option>
                        {(Cargos ?? [])
                          .filter(c => {
                            if (modelEdit && modelEdit.id === c.id) return false
                            if (descendentes.has(c.id)) return false
                            return true
                          })
                          .sort((a, b) => a.nomeCargo.localeCompare(b.nomeCargo, 'pt-BR'))
                          .map(c => (
                            <option key={c.id} value={c.id}>{c.nomeCargo}</option>
                          ))}
                      </SelectCmp>
                      {index > 0 && (
                        <ButtonCmp VarColor="Red" onClick={() => removeTrilha(index)}><FaTrash/></ButtonCmp>
                      )}
                    </Flex>
                  )
                })}
                <ButtonCmp VarColor="Green2" onClick={addTrilha} w={'12rem'} leftIcon={<FaPlus/>}>Adicionar Trilha</ButtonCmp>
              </Flex>

              <Flex flexDir={'column'} alignItems={'end'} w={'100%'}>
                {model.cargosSuperiores?.map((cargo, index) => {
                  return (
                    <Flex key={index} gap="1rem" align="flex-end" w={'100%'}>
                      <SelectCmp
                        w="100%"
                        mb={'10px'}
                        title={`Cargo superior (${index + 1})`}
                        placeholder="Selecione o cargo superior..."
                        value={cargo.cargoSuperiorId}
                        OnChange={(v) => handleCargosSuperioresChange(index, 'cargoSuperiorId', v, buscarNomeCargoPorID(v))}
                      >
                        <option value="">Ninguém (Topo da hierarquia)</option>
                        {(Cargos ?? [])
                          .filter(c => {
                            if (modelEdit && modelEdit.id === c.id) return false
                            return true
                          })
                          .sort((a, b) => a.nomeCargo.localeCompare(b.nomeCargo, 'pt-BR'))
                          .map(c => (
                            <option key={c.id} value={c.id}>{c.nomeCargo}</option>
                          ))}
                      </SelectCmp>
                      {index > 0 && (
                        <ButtonCmp mb={'10px'} VarColor="Red" onClick={() => removeCargoSuperior(index)}><FaTrash/></ButtonCmp>
                      )}
                    </Flex>
                  )
                })}
                <ButtonCmp VarColor="Green2" onClick={addCargoSuperior} w={'12rem'} leftIcon={<FaPlus/>}>Adicionar Cargo Superior</ButtonCmp>
              </Flex>

              <Flex gap={'1rem'}>
                <SelectCmp
                  w={'100%'}
                  title="Atuação *"
                  placeholder={'Selecione a atuação...'}
                  isInvalid={invalidFlags.AtuacaoTrue}
                  value={model.atuacao}
                  OnChange={(v) => handleChange('atuacao', v)}
                >
                  <option value="">Selecionar atuação</option>
                  <option value="Administrativo">Administrativo</option>
                  <option value="Execução">Execução</option>
                </SelectCmp>
                <SelectCmp
                  w={'100%'}
                  title="Nível hierárquico *"
                  placeholder={'Selecione o nível hierárquico...'}
                  value={model.hierarquia}
                  isInvalid={invalidFlags.HierarquiaTrue}
                  OnChange={(v) => handleChange('hierarquia', v)}
                >
                  <option value="">Selecionar nível hierárquico</option>
                  <option value="Chefia">Chefia</option>
                  <option value="Coordenação">Coordenação</option>
                  <option value="Direção">Direção</option>
                  <option value="Gerência">Gerência</option>
                  <option value="Produtivo">Produtivo</option>
                  <option value="Super intendência">Super intendência</option>
                  <option value="Supervisão">Supervisão</option>
                </SelectCmp>
                <InputCmp label="CBO *" placeholder={'Digite o CBO do cargo...'} value={model.cbo} OnChange={(v) => handleChange('cbo', v)} isInvalid={invalidFlags.CboTrue}/>
              </Flex>
            </Flex>
          </FormControl>

          <Flex justifyContent="end" gap=".375rem" mt="1rem">
            <ButtonCmp VarColor="c6" onClick={onClose}>Cancelar</ButtonCmp>
            <ButtonCmp VarColor="Green2" onClick={checkCreate}>{modelEdit ? 'Salvar alterações' : 'Criar cargo'}</ButtonCmp>
          </Flex>
        </WhiteModal>
      </LoadingContainer>
    </Modal>
  )
}
